export default __webpack_public_path__ + "static/patient-brochure-tablet-0a376bd3023d8434192d1e4bde4ed30e.png";